import { ref, computed } from "vue";
import firebase from "firebase/app";
import "firebase/firestore";
import moment from "moment";

const state = ref({ events: [], rangeStart: null, rangeEnd: null });
export default function useEvents() {
  const projectsRef = firebase.firestore().collection("projects");

  function setRange(start, end, addMonths = 0, addDays = 0) {
    if (start) {
      state.value.rangeStart = moment(start)
        .add(-addMonths, "months")
        .add(addDays, "days")
        .toDate();
    }

    if (end) {
      state.value.rangeEnd = moment(end)
        .add(addMonths, "months")
        .add(addDays, "days")
        .toDate();
    }
  }

  async function fetchEvents(projectId, datesRange, listWidget = false) {
    const rangeStart = firebase.firestore.Timestamp.fromDate(datesRange.start);
    const rangeEnd = firebase.firestore.Timestamp.fromDate(datesRange.end);

    const calendarEvents = [];
    try {
      const res = await projectsRef
        .doc(projectId)
        .collection("events")
        .where("start", ">=", rangeStart)
        .where("start", "<=", rangeEnd)
        .get();
      if (!res.empty) {
        res.forEach(doc => {
          const calEvent = doc.data();
          calEvent.id = doc.id;
          calendarEvents.push(calEvent);
        });
      }
    } catch (err) {
      console.log(err);
    }

    if (!listWidget) {
      calendarEvents.forEach(event => {
        state.value.events.push(event);
      });
    }

    return calendarEvents;
  }

  async function saveEvent(projectId, calEvent) {
    delete calEvent.id;
    try {
      const res = await projectsRef
        .doc(projectId)
        .collection("events")
        .add(calEvent);

      calEvent.id = res.id;
      state.value.events.push(calEvent);
    } catch (err) {
      console.log(err);
    }

    return state.value.events;
  }

  async function updateEvent(projectId, calEvent) {
    const eventId = calEvent.id;
    delete calEvent.id;
    try {
      await projectsRef
        .doc(projectId)
        .collection("events")
        .doc(eventId)
        .update(calEvent);

      calEvent.id = eventId;
      const index = state.value.events.findIndex(
        item => item.id === calEvent.id
      );
      state.value.events[index] = calEvent;
    } catch (err) {
      console.log(err);
    }

    return state.value.events;
  }

  async function deleteEvent(projectId, calEventId) {
    try {
      await projectsRef
        .doc(projectId)
        .collection("events")
        .doc(calEventId)
        .delete();
    } catch (err) {
      console.log(err);
    }

    const deleteIndex = state.value.events.findIndex(
      item => item.id === calEventId
    );
    if (deleteIndex !== -1) {
      state.value.events.splice(deleteIndex, 1);
    }

    return state.value.events;
  }

  return {
    events: state.value.events,
    setRange,
    rangeStart: computed(() => {
      return state.value.rangeStart;
    }),
    rangeEnd: computed(() => {
      return state.value.rangeEnd;
    }),
    fetchEvents,
    saveEvent,
    updateEvent,
    deleteEvent
  };
}
